export default function (url) {
    let cleanUrl = url.toLowerCase()
    cleanUrl = cleanUrl.replace('&amp;', '')
    return encodeURIComponent(cleanUrl).replace(/%20/g, '_')
}
